import type { ReactNode } from 'react';
import { IcnCheck, IcnClose } from '../../icons/index.js';
import type { ToastTone } from './types.js';

/** Tiny inline glyphs for info / warning — keep icon library lean.
 *  Success reuses the existing animated IcnCheck (tick-in on mount). */
function InfoGlyph(): ReactNode {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <rect x="7.1" y="7" width="1.8" height="5" rx="0.9" fill="currentColor" />
      <rect x="7.1" y="4" width="1.8" height="1.8" rx="0.9" fill="currentColor" />
    </svg>
  );
}

function WarningGlyph(): ReactNode {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 2 14.5 13 H1.5 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect x="7.15" y="6" width="1.7" height="4.2" rx="0.85" fill="currentColor" />
      <rect x="7.15" y="11" width="1.7" height="1.7" rx="0.85" fill="currentColor" />
    </svg>
  );
}

function DangerGlyph(): ReactNode {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M5.5 5.5 10.5 10.5 M10.5 5.5 5.5 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function defaultIconForTone(tone: ToastTone): ReactNode {
  if (tone === 'success') return <IcnCheck size={14} />;
  if (tone === 'info') return <InfoGlyph />;
  if (tone === 'warning') return <WarningGlyph />;
  if (tone === 'danger') return <DangerGlyph />;
  if (tone === 'accent') return <IcnCheck size={14} />;
  // neutral — no icon (renders a small dot)
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="3" cy="3" r="3" />
    </svg>
  );
}

export { IcnClose };
